var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27327 2.82552C8.27327 2.41423 7.94238 2.08334 7.53109 2.08334C7.11979 2.08334 6.7889 2.41423 6.7889 2.82552V4.0625H5.55192C4.46029 4.0625 3.57275 4.95004 3.57275 6.04167V15.9375C3.57275 17.0291 4.46029 17.9167 5.55192 17.9167H15.4478C16.5394 17.9167 17.4269 17.0291 17.4269 15.9375V6.04167C17.4269 4.95004 16.5394 4.0625 15.4478 4.0625H14.2108V2.82552C14.2108 2.41423 13.8799 2.08334 13.4686 2.08334C13.0573 2.08334 12.7264 2.41423 12.7264 2.82552V4.0625H8.27327V2.82552ZM5.05713 6.04167H15.9425V15.9375C15.9425 16.2096 15.7199 16.4323 15.4478 16.4323H5.55192C5.27979 16.4323 5.05713 16.2096 5.05713 15.9375V6.04167Z",
    fill: "#086EC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5415 10.7422C6.5415 11.1535 6.8724 11.4844 7.28369 11.4844H13.716C14.1273 11.4844 14.4582 11.1535 14.4582 10.7422C14.4582 10.3309 14.1273 10 13.716 10H7.28369C6.8724 10 6.5415 10.3309 6.5415 10.7422ZM7.28369 12.9688C6.8724 12.9688 6.5415 13.2996 6.5415 13.7109C6.5415 14.1222 6.8724 14.4531 7.28369 14.4531H10.7472C11.1585 14.4531 11.4894 14.1222 11.4894 13.7109C11.4894 13.2996 11.1585 12.9688 10.7472 12.9688H7.28369Z",
    fill: "#086EC5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e473abaa4c7201848196356dd00439c1.svg";
export { ForwardRef as ReactComponent };